module.exports = __webpack_public_path__ + "img/auto-loan-transportation.8f5e67f8.png";